import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-cf3e8cc6"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "preview-wrapper"
};
const _hoisted_2 = {
  class: "video-list"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "video-content"
};
const _hoisted_5 = {
  class: "top"
};
const _hoisted_6 = {
  class: "course-name"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/463dc604f3b7401391cd2496361df06c.png"
}, null, -1));

const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "course-info"
};
const _hoisted_10 = {
  class: "video-player"
};
import VideoPreview from './VideoPreview.vue';
export default {
  props: {
    show: Boolean,
    videoList: Array,
    activeIndex: Number
  },
  emits: ['update:show', 'update:activeIndex'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const videoInfo = computed(() => {
      return props.videoList[props.activeIndex];
    });

    const handleClose = () => {
      emit('update:show', false);
    };

    const changeVideo = index => {
      emit('update:activeIndex', index);
    };

    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(show) ? show.value = $event : null),
        width: "960px",
        "before-close": handleClose,
        "destroy-on-close": "",
        "append-to-body": "",
        "close-on-click-modal": false,
        "show-close": false,
        "modal-class": "video-preview-dialog"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.videoList, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["video-name", {
              'active': __props.activeIndex == index
            }]),
            key: item.id,
            onClick: $event => changeVideo(index)
          }, _toDisplayString(item.name), 11, _hoisted_3);
        }), 128))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(videoInfo).name), 1), _createElementVNode("div", {
          class: "icon-close",
          onClick: handleClose
        }, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_unref(videoInfo).teacher), 1), _createElementVNode("span", null, _toDisplayString(_unref(videoInfo).college), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(VideoPreview, {
          videoUrl: _unref(videoInfo).jump_url
        }, null, 8, ["videoUrl"])])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};